import React from 'react'
import PropTypes from 'prop-types'
import { Container, MainTextSpan, SecondaryTextSpan } from './styles'

const { REACT_APP_SIGNUP_DOC_URL: signupDocUrl } = process.env

const ExpiredSignupWarn = () => {
    return (
        <Container>
            <MainTextSpan>Signup Expirado!</MainTextSpan>
            <SecondaryTextSpan>
                Realize o{' '}
                <a id={'ExpiredSignupWarn--signup-doc'} href={signupDocUrl}>
                    signup
                </a>{' '}
                novamente.
            </SecondaryTextSpan>
        </Container>
    )
}

ExpiredSignupWarn.propTypes = {
    location: PropTypes.object,
}
export default ExpiredSignupWarn
